/** @format */

const getAnchor = (pathname: string) => {
  if (pathname.includes('home/main/status')) {
    return '#project';
  }
  if (pathname.includes('home/project/edit')) {
    return '#setup';
  }
  if (pathname.includes('home/digital-cast')) {
    return '#digital-cast';
  }
  return '';
};

export {getAnchor};
